import React from 'react';
import { Link } from 'react-router-dom';
import LegalLayout, { LegalSection } from '../components/LegalLayout';

export default function PrivacyPolicy() {
  return (
    <LegalLayout eyebrow="Legal" title="Privacy Policy" updated="August 8, 2026">
      <LegalSection title="1. Overview">
        <p>
          This Privacy Policy explains what information Tech Dynasty ("we", "us", "our")
          collects when you use our website and mobile apps (the "Service"), how we use it, and
          the choices you have.
        </p>
      </LegalSection>

      <LegalSection title="2. Information We Collect">
        <ul className="list-disc space-y-1 pl-5">
          <li><strong>Account information</strong> — name, email address, and authentication data when you register or sign in (including via Google sign-in).</li>
          <li><strong>Gameplay data</strong> — your in-game progress, purchases, and settings, so your empire syncs across devices.</li>
          <li><strong>Device & usage data</strong> — device type, OS version, app version, and basic analytics to help us fix bugs and improve the Service.</li>
          <li><strong>Support communications</strong> — anything you send us when contacting Support.</li>
        </ul>
      </LegalSection>

      <LegalSection title="3. How We Use Information">
        <ul className="list-disc space-y-1 pl-5">
          <li>To create and secure your account, and to save/sync your game progress.</li>
          <li>To operate, maintain, and improve the Service.</li>
          <li>To communicate with you about updates, security notices, or support requests.</li>
          <li>To detect, prevent, and address cheating, fraud, or abuse.</li>
        </ul>
        <p>We do not sell your personal information.</p>
      </LegalSection>

      <LegalSection title="4. Authentication & Third-Party Services">
        <p>
          We use Google Firebase for authentication and data storage. When you sign in with
          Google, Google shares basic profile information (name, email) with us as permitted by
          your Google account settings. These providers process data under their own privacy
          policies.
        </p>
      </LegalSection>

      <LegalSection title="5. Data Retention">
        <p>
          We keep your account and gameplay data for as long as your account is active. You can
          request deletion of your account and associated data at any time — see "Your Choices"
          below.
        </p>
      </LegalSection>

      <LegalSection title="6. Your Choices">
        <ul className="list-disc space-y-1 pl-5">
          <li>Access or update your account information from your Profile page.</li>
          <li>Request a copy or deletion of your data by contacting Support.</li>
          <li>Log out or delete your account to stop further data collection tied to it.</li>
        </ul>
      </LegalSection>

      <LegalSection title="7. Children's Privacy">
        <p>
          The Service is not directed at children under 13, and we do not knowingly collect
          personal information from children under 13. If you believe a child has provided us
          personal information, please contact us so we can remove it.
        </p>
      </LegalSection>

      <LegalSection title="8. Security">
        <p>
          We use industry-standard measures (including Firebase Authentication and encrypted
          transport) to protect your information. No method of transmission or storage is 100%
          secure, so we can't guarantee absolute security.
        </p>
      </LegalSection>

      <LegalSection title="9. Changes to This Policy">
        <p>
          We may update this Privacy Policy from time to time. Material changes will be reflected
          by updating the "Last updated" date above.
        </p>
      </LegalSection>

      <LegalSection title="10. Contact Us">
        <p>
          Questions about this policy or your data? Visit our Support page at{' '}
          <Link to="/support" className="font-bold text-[var(--brand-primary)] hover:underline">
            playtechdynasty.com/support
          </Link>.
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
